export const REACT_APP_API_PLATFORM_URL = (import.meta.env.VITE_API_PLATFORM_URL as string) ?? '';
export const BASE_URL = (import.meta.env.VITE_BASE_URL as string) ?? '';
export const BRICKWISE_APP_FRONTEND_URL = (import.meta.env.VITE_BRICKWISE_APP_FRONTEND_URL as string) ?? '';
export const DEBUG = true;
